import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LogOut from "../components/LogOut";
import editplatform from "../assets/pen-platform.png";
import editnumber from "../assets/pen-number.png";

const Admin = () => {
  const [users, setUsers] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [modalType, setModalType] = useState(""); // platform / analysis
  const [formData, setFormData] = useState({});
  const token = localStorage.getItem("token");
  const isGust = localStorage.getItem("role") === "gust";
  const handleRefresh = () => {
    window.location.reload(); // يعمل reload بعد التنقل
  };
  const fieldLabels = {
    revenue: "العوائد",
    spending: "الصرف",
    impressions: "مرات الظهور",
    orders: "الطلبات",
    roi: "العائد على الاستثمار",
    checkout_page_visits: "الوصول لصفحة إتمام الطلب",
    cpc: "تكلفة النقرة",
    cpa: "تكلفة جلب الطلب",
    cart_additions: "عدد إضافات للسلة",
    clicks: "عدد النقرات",
    ctr: "نسبة النقر للظهور",
  };

  useEffect(() => {
    fetch("http://backend.goldensection.agency/public/api/getuser", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setUsers(data.users || []))
      .catch((err) => console.error(err));
  }, [token]);

  const handlePlatformEdit = (platform) => {
    setModalType("platform");
    setModalData(platform);
    setFormData({ status: platform.status || "off" });
  };

  const handleAnalysisEdit = (analysis) => {
    setModalType("analysis");
    setModalData(analysis);
    setFormData({ ...analysis });
  };

  const closeModal = () => {
    setModalData(null);
    setModalType("");
    setFormData({});
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSave = () => {
    const apiUrl =
      modalType === "platform"
        ? `http://backend.goldensection.agency/public/api/updatesocialmedia/${modalData.id}`
        : `http://backend.goldensection.agency/public/api/updateanalysis/${modalData.id}`;

    console.log("Saving data:", formData, "to", apiUrl);

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Response:", data);
        alert("تم حفظ البيانات بنجاح!");
        closeModal(); // تغلق المودال
        window.location.reload(); // تعمل ريفريش للصفحة لعرض البيانات المحدثة
      })
      .catch((err) => console.error(err));
  };

  return (
    <div>
      <div className="navbar_admin">
        <LogOut />
        <h2>لوحة التحكم في حسابات العملاء</h2>
        {!isGust && (
          <>
            <button className="add1">
              <Link to="/addclient">اضافة عميل جديد</Link>
            </button>
            <button className="update">
              <Link id="a1" to="/update">
                تعديل بيانات العملاء
              </Link>
            </button>
          </>
        )}

        {/* <button className="add2">
          <Link to="/addplatform">اضافة منصة جديدة</Link>
        </button> */}
        {/* <button className="add3">
          <Link to="/addnumber">اضافة رقم جديد </Link>
        </button> */}
        <button className="report">
          <Link id="a1" to="/report">
            تقارير اخرى
          </Link>
        </button>
        <button className="comreport">
          <Link id="a1" to="/complete-report">
            التقرير الشهري
          </Link>
        </button>
        <button onClick={handleRefresh} className="seo">
          <Link id="a1" to="/seo">
            SEO
          </Link>
        </button>
        <button onClick={handleRefresh} className="whats">
          <Link id="a1" to="/whats">
            حملات الواتس اب
          </Link>
        </button>
      </div>

      <div className="admin_area">
        <table className="users-table">
          <thead>
            <tr>
              <th>اسم المستخدم</th>
              <th>الصورة</th>
              <th>المنصة</th>
              <th>العوائد</th>
              <th>الصرف</th>
              <th>مرات الظهور</th>
              <th>الطلبات</th>
              <th>العائد على الاستثمار</th>
              <th>الوصول لصفحة اتمام الطلب</th>
              <th>تكلفة النقرة</th>
              <th>تكلفة جلب الطلب</th>
              <th>عدد اضافات للسلة</th>
              <th>عدد النقرات</th>
              <th>عدد مرات الظهور</th>
              <th>نسبة النقر للظهور</th>
              {!isGust && <th>الإجراءات</th>}
            </tr>
          </thead>
          <tbody>
            {users.map((user) => {
              const totalRows = user.social_media.reduce(
                (acc, platform) => acc + platform.analyses.length,
                0,
              );
              let firstRow = true;

              return user.social_media.map((platform) =>
                platform.analyses.map((analysis, idx) => {
                  const row = (
                    <tr key={`${user.id}-${platform.id}-${idx}`}>
                      {firstRow && (
                        <>
                          <td rowSpan={totalRows}>{user.name}</td>
                          <td rowSpan={totalRows}>
                            {user.image ? (
                              <img
                                src={`http://backend.goldensection.agency/public/${user.image}`}
                                alt={user.name}
                                style={{ width: "50px", borderRadius: "50%" }}
                              />
                            ) : (
                              "لا توجد صورة"
                            )}
                          </td>
                        </>
                      )}
                      <td>{platform.platform}</td>
                      <td>{analysis.revenue}</td>
                      <td>{analysis.spending}</td>
                      <td>{analysis.impressions}</td>
                      <td>{analysis.orders}</td>
                      <td>{analysis.roi || 0}</td>
                      <td>{analysis.checkout_page_visits || 0}</td>
                      <td>{analysis.cpc || 0}</td>
                      <td>{analysis.cpa || 0}</td>
                      <td>{analysis.cart_additions || 0}</td>
                      <td>{analysis.clicks || 0}</td>
                      <td>{analysis.impressions || 0}</td>
                      <td>{analysis.ctr || 0}</td>
                      {!isGust && (
                        <td className="editdelet">
                          <button
                            className="edit-btn"
                            onClick={() => handlePlatformEdit(platform)}
                          >
                            <img src={editplatform} alt="edit" />
                          </button>
                          <button
                            className="delete-btn"
                            onClick={() => handleAnalysisEdit(analysis)}
                          >
                            <img src={editnumber} alt="edit" />
                          </button>
                        </td>
                      )}
                    </tr>
                  );

                  firstRow = false;
                  return row;
                }),
              );
            })}
          </tbody>
        </table>
      </div>

      {/* البوب أب القابل للتعديل */}
      {modalData && (
        <div className="modal-overlay">
          <div className="modal">
            <button className="close-btn" onClick={closeModal}>
              X
            </button>
            {modalType === "platform" && (
              <div>
                <h3>تعديل المنصة: {modalData.platform}</h3>
                <label>
                  الحالة:
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="on">On</option>
                    <option value="off">Off</option>
                  </select>
                </label>
              </div>
            )}
            {modalType === "analysis" && (
              <div className="modal-analysis">
                <h3>تعديل الرقم</h3>
                <table className="analysis-table">
                  <thead>
                    <tr>
                      <th>البند</th>
                      <th>القيمة</th>
                      <th>عرض / إخفاء</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(formData)
                      .filter(
                        ([key, _]) =>
                          ![
                            "id",
                            "social_media_id",
                            "date",
                            "created_at",
                            "updated_at",
                          ].includes(key),
                      )
                      .map(([key, value]) => {
                        if (key.startsWith("show_")) return null; // الـ show handled separately
                        const displayName = fieldLabels[key] || key; // الترجمة أو المفتاح نفسه
                        return (
                          <tr key={key}>
                            <td>{displayName}</td>
                            <td>
                              <input
                                type="text"
                                name={key}
                                value={value}
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <button
                                className={`toggle-btn ${
                                  formData[`show_${key}`] ? "on" : "off"
                                }`}
                                onClick={() =>
                                  setFormData({
                                    ...formData,
                                    [`show_${key}`]: !formData[`show_${key}`],
                                  })
                                }
                              >
                                {formData[`show_${key}`] ? "TRUE" : "FALSE"}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}

            <button className="save-btn" onClick={handleSave}>
              حفظ
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
